import React, { useEffect, useState } from 'react';

//tabla
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Paper } from '@material-ui/core';
import { wsGet } from 'services/WService';

export default function StockData({ entity, idGroup, tipo }) {
  const [group, setGroup] = useState([]);

  async function getGroup() {
    let response = await wsGet(entity, idGroup);
    if (response.success) setGroup(response.data);
  }

  useEffect(() => {
    getGroup();
  }, [idGroup]);

  return group.products?.length > 0 ? (
    <TableContainer component={Paper}>
      <Table style={{ minWidth: 1000 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Código</TableCell>
            <TableCell>Nombre</TableCell>
            {group?.products[0]?.stocks?.map((stock, i) => (
              <TableCell key={i}>{stock.WhsName}</TableCell>
            ))}
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {group.products.map((item, i) => (
            <TableRow key={i}>
              <TableCell>{i + 1}</TableCell>
              <TableCell>{(tipo === 'B' ? item.ItemCode : item.item_code)}</TableCell>
              <TableCell>{(tipo === 'B' ? item.ItemName : item.item_name)}</TableCell>
              {item.stocks?.map((stock, i) => (
                <TableCell key={i}>{stock.aviable}</TableCell>
              ))}
              <TableCell>
                {Object.values(item.stocks).reduce((t, { aviable }) => t + aviable, 0)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <></>
  );
}
